import { render, staticRenderFns } from "./SkuScannerDialog.vue?vue&type=template&id=560dc379&scoped=true&"
import script from "./SkuScannerDialog.ts?vue&type=script&lang=ts&"
export * from "./SkuScannerDialog.ts?vue&type=script&lang=ts&"
import style0 from "./SkuScannerDialog.vue?vue&type=style&index=0&id=560dc379&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560dc379",
  null
  
)

export default component.exports